import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import './ViewProfile.scss'

const ViewProfile = () => {

    React.useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    return (
        <div className="view-profile">

            <div 
                data-aos="fade-right" 
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
            >
                <p>
                    Want to know More? View my Profile.
                </p>
            </div>

            <div 
                data-aos="fade-left" 
                data-aos-delay="50"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
            >
                <button className="resume" onClick={() => window.open('https://drive.google.com/file/d/1iR2daR1Y-13RTIo-LsMuX9DHtuzBQ551/view?usp=drive_link')}>
                    View Profile
                </button>
            </div>
        </div>
    );
}

export default ViewProfile;